export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8736.a58fef93.jpg";